<template>
    <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card class="pa-5">
      <!-- <div>
        <v-img
          style="border-radius: 5px"
          height="150"
          src="@/assets/alert.jpg"
        ></v-img>
        <v-card-text
          v-show="!!message"
          class="pa-4 text-center px-0 black--text"
          v-html="message"
        />
        <v-card-actions class="pa-0">
          <v-btn
            color="primary"
            outlined
            @click.native="agree"
          >
            {{$t('yes')}}
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="!options.noconfirm"
            color="grey"
            outlined
            @click.native="cancel"
          >
            {{$t('cancel')}}
          </v-btn>
        </v-card-actions>
      </div> -->
      <v-container class="pa-0 d-flex justify-end">
        <v-icon size="20" @click="dialog = false">mdi-close</v-icon>
      </v-container>
      <div class="d-flex flex-column gap-3">
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="70" color="red">mdi-alert</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center">
          <v-card-text class="pa-0 text-body-1">{{ message }}</v-card-text>
        </v-container>
        <v-container class="pa-0 d-flex gap-2">
          <v-btn
            color="error"
            @click.native="agree"
            height="32"
            class="flex-fill"
          >
            {{$t('yes')}}
          </v-btn>
          <v-btn
            v-if="!options.noconfirm"
            color="error"
            outlined
            @click.native="cancel"
            height="32"
            class="flex-fill"
          >
            {{$t('cancel')}}
          </v-btn>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Index',
  data: function () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'grey lighten-3',
        width: 300,
        zIndex: 200,
        noconfirm: false
      }
    }
  },
  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
